import { AssociatedPersonnelThemeSizeConfig } from './types';

const large: AssociatedPersonnelThemeSizeConfig = {
  associatedPersonnel: {},
};

export default large;
